import { useNavigate } from 'react-router-dom';
import styles from '../static/styles/EditProfile.module.css';
import { useEffect } from 'react';

const Thankyou = () => {
    const navigate = useNavigate();
    useEffect(() => {
        document.title = "Thankyou | Ufone ESG";
    }, []);

    return (
        <div className={styles.editProfile}>
            <h3 style={{textAlign: 'center', color: '#E3931B'}}>THANKYOU!</h3>
            <p style={{textAlign:'center'}}>We have received your redemption request, and our team will contact you within 24 hours.</p>
            <p style={{textAlign:'center'}}>Please note that our business hours are Monday to Friday, from 9:00 AM to 10:00 PM.</p>
            <p style={{textAlign:'center'}}>Any redemption requests submitted after 10:00 PM on Friday will be processed on the following Monday </p>
            <p style={{textAlign:'center'}}>Happy Gaming!</p>
            <button
                className={styles.saveButton}
                onClick={() => {navigate('/');}}
            >
                Home
            </button>
        </div>
    );
};

export default Thankyou;